import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrganizationDetails } from "../../service/organization/organizationService";
import { getSellerOrgApiCode } from "../../config/sellerOrgConfig";

interface Organization {
  id: number;
  organization_name: string;
  organization_code: string;
  logo: string;
  favicon_url?: string;
  whatsapp_support_number?: string;
  short_description: string;
  long_description: string;
  address: string;
  email: string;
  contact_number: string;
  website: string;
  gst_number: string;
  timezone: string;
  currency: string;
  date_format: string;
  account_number: string;
  bank_name: string;
  ifsc_code: string;
  branch_name: string;
  account_holder_name: string;
  pan_number: string;
  name_as_per_pan: string;
  date_of_incorporation: string;
  status: boolean;
  created_at: string;
  updated_at: string;
}

interface OrganizationState {
  data: Organization | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrganizationState = {
  data: null,
  loading: false,
  error: null,
};


export const fetchOrganization = createAsyncThunk(
  "organization/fetchOrganization",
  async (_, { rejectWithValue }) => {
    try {
      const organizationId = getSellerOrgApiCode();
      const response = await getOrganizationDetails(organizationId);
      return response.data.data; 
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch organization");
    }
  }
);

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Update organization data
      })
      .addCase(fetchOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string; // Store error message
      });
  },
});

export default organizationSlice.reducer;
